import { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  Label,
  FormGroup,
  Input,
  Row,
  Col,
} from "reactstrap";
import { CalenderIcon } from "../../Icon";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
  downloadInvoiceGenerationReportsApi,
  downloadOtherInvoicesReportsApi,
} from "../../../apis/invoiceGenerationApis";
import FileSaver from "file-saver";
import {
  DownloadInvoiceGenerationReportsType,
  DownloadOtherInvoicesReportsType,
} from "../../../commonTypes/invoiceGenerationTypes";
import Loader from "../../commons/Loader";
import { NewDownloadIcon, NewDownloadIconActive } from "../../../assets/images";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "../Filter.tsx/filter.scss";
import { RadioContainer } from "../../commons";

type RadioOptionType = {
  id: string;
  name: string;
};
const PAYMENT_SECTION_FILTER_OPTIONS: RadioOptionType[] = [
  { id: "1", name: "With Payment" },
  {
    id: "0",
    name: "Without Payment",
  },
];
type AppProps = {
  type: string;
  client_code: number;
  token: string | null;
  company_name: string;
  attachment: string;
  approved: string;
  invoiceDate: string;
  invoiceNumber: string;
  paymentStatus?: string;
  searchData: string;
};

const DownloadInvoiceGenerationReports = ({
  type,
  client_code,
  token,
  company_name,
  attachment,
  approved,
  invoiceDate,
  invoiceNumber,
  paymentStatus,
  searchData,
}: AppProps) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [dateType, setDateType] = useState<string>("");
  const [dateOfInvoiceType, setDateOfInvoiceType] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [paymentStatusRadio, setPaymentStatusRadio] = useState(
    PAYMENT_SECTION_FILTER_OPTIONS[0]?.id
  );

  const toggleShowDropdown = () => {
    setShowDropdown(!showDropdown);
    handleDateSelect();
  };

  const handleCancel = () => {
    setStartDate(null);
    setEndDate(null);
    setShowDropdown(!showDropdown);
  };

  const handleStartDate = (date: any) => {
    setStartDate(date);
    setEndDate(null);
  };

  const handleSetPaymentValue = (radioValue: string) => {
    setPaymentStatusRadio(radioValue);
  };

  const handleDateSelect = () => {
    switch (type) {
      case "expenses":
      case "revenues":
        return setDateOfInvoiceType("voucher_invoice_date");
      case "others":
        return setDateOfInvoiceType("date_of_invoice");
      default:
        return;
    }
  };

  const handleDownload = () => {
    setIsLoading(true);
    setShowDropdown(false);
    if (type === "revenues" || type === "expenses") {
      handlePrepareExpenseRevenueReportData();
    } else {
      handlePrepareOthersReportData();
    }
  };

  const handlePrepareExpenseRevenueReportData = () => {
    let params: DownloadInvoiceGenerationReportsType = {
      start_date: moment(startDate).format("DD-MM-YYYY"),
      end_date: moment(endDate).format("DD-MM-YYYY"),
      client_code: client_code,
      type: type ? type : "",
      date_type: dateType,
      invoice_voucher_number: invoiceNumber,
      date_of_invoice: invoiceDate,
      attachment: attachment,
      approved: approved,
      payment_status: paymentStatus,
      search_term: searchData,
      token,
      payment_section: +paymentStatusRadio,
    };

    if (params && token) {
      handleDownloadExpenseRevenueInvoiceReport(params);
    }
    setDateType("");
  };

  const handlePrepareOthersReportData = () => {
    let params: DownloadOtherInvoicesReportsType = {
      start_date: moment(startDate).format("DD-MM-YYYY"),
      end_date: moment(endDate).format("DD-MM-YYYY"),
      client_code: client_code,
      date_type: dateType,
      date_of_invoice: invoiceDate,
      attachment: attachment,
      approved: approved,
      search_term: searchData,
      token,
    };

    if (params && token) {
      handleDownloadOtherInvoiceReport(params);
    }
    setDateType("");
  };

  const handleDownloadExpenseRevenueInvoiceReport = (params: any) => {
    let reportName = `${company_name ? company_name : "reports"}${
      type == "expenses" ? "_expenses_" : "_sales_"
    }${moment(Date.now()).format("DD-MM-YYYY")}.csv`;

    downloadInvoiceGenerationReportsApi(params).then((response) => {
      setIsLoading(false);
      let blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
      FileSaver.saveAs(blob, reportName);
    });
  };

  const handleDownloadOtherInvoiceReport = (params: any) => {
    let reportName = company_name
      ? company_name +
        "_others_" +
        moment(Date.now()).format("DD-MM-YYYY") +
        ".csv"
      : "report";
    downloadOtherInvoicesReportsApi(params).then((response) => {
      setIsLoading(false);
      let blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
      FileSaver.saveAs(blob, reportName);
    });
  };

  return (
    <>
      <ButtonDropdown
        isOpen={showDropdown}
        toggle={toggleShowDropdown}
        className="download-report-btn"
        style={
          showDropdown
            ? {
                color: "#dd4433",
                backgroundColor: "#fff6f5",
              }
            : {}
        }
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          overlay={
            <Tooltip id="button-view-download-invoice">
              Download Reports
            </Tooltip>
          }
        >
          <DropdownToggle
            caret
            outline
            style={
              showDropdown
                ? {
                    color: "#dd4433",
                    backgroundColor: "#fff6f5",
                  }
                : { border: "1px solid#bfcbe1" }
            }
          >
            {/* <DownloadIcon />  */}
            <img
              src={showDropdown ? NewDownloadIconActive : NewDownloadIcon}
              alt="download icon"
            />
          </DropdownToggle>
        </OverlayTrigger>
        <DropdownMenu right>
          <div className="download-dropdown p-3">
            <h4>Download Report</h4>
            <FormGroup>
              <Input
                type="select"
                name="select"
                id="dateType"
                onChange={(e) => setDateType(e.target.value)}
              >
                <option value="" disabled selected>
                  Select your option
                </option>
                <option value={dateOfInvoiceType}>Date of Invoice</option>
                <option value="updated_at">Date Added/Modified</option>
              </Input>
            </FormGroup>
            {type !== "others" ? (
              <RadioContainer
                optionsList={PAYMENT_SECTION_FILTER_OPTIONS}
                handleSetRadioValue={handleSetPaymentValue}
                radioValue={paymentStatusRadio}
                alignment="vertical"
              />
            ) : (
              ""
            )}
            <Row>
              <Col md={6} className="form-group">
                <div>Start Date </div>
                <Row>
                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={startDate}
                        onChange={handleStartDate}
                        selectsStart
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={6} className="form-group">
                <div>End Date</div>
                <Row>
                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={endDate}
                        onChange={(date: any) => setEndDate(date)}
                        selectsEnd
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={12} className="text-right">
                <button
                  className="btn btn-outline-secondary mr-3"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleDownload}
                  disabled={startDate && endDate && dateType ? false : true}
                >
                  Download
                </button>
              </Col>
            </Row>
          </div>
        </DropdownMenu>
      </ButtonDropdown>
      {isLoading && <Loader />}
    </>
  );
};

export default DownloadInvoiceGenerationReports;
